import React from 'react';
import { LockIcon } from 'lucide-react';
import { PaymentBadges } from './PaymentBadges';
export function TrustBar() {
  return <section className="bg-white border-y border-gray-200 py-10 px-4" data-id="element-249">
      <div className="max-w-6xl mx-auto" data-id="element-250">
        <div className="text-center mb-8" data-id="element-251">
          <div className="flex items-center justify-center space-x-2 mb-2" data-id="element-252">
            <LockIcon className="w-6 h-6 text-green-600" data-id="element-253" />
            <h2 className="text-2xl font-bold text-stone-900" data-id="element-254">
              Transazione Sicura al 100%
            </h2>
          </div>
          <p className="text-gray-600" data-id="element-255">
            Il tuo acquisto è protetto e i tuoi dati sono al sicuro.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 mb-8 text-center" data-id="element-256">
          <div className="flex flex-col items-center" data-id="element-257">
            <span className="font-bold text-stone-800 text-sm mb-1" data-id="element-258">
              Pagamento Sicuro
            </span>
            <span className="text-xs text-gray-500" data-id="element-259">
              Crittografia SSL 256-bit
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-260">
            <span className="font-bold text-stone-800 text-sm mb-1" data-id="element-261">
              Garanzia 100%
            </span>
            <span className="text-xs text-gray-500" data-id="element-262">45 giorni di prova</span>
          </div>
          <div className="flex flex-col items-center" data-id="element-263">
            <span className="font-bold text-stone-800 text-sm mb-1" data-id="element-264">
              Accesso Immediato
            </span>
            <span className="text-xs text-gray-500" data-id="element-265">Download istantaneo</span>
          </div>
          <div className="flex flex-col items-center" data-id="element-266">
            <span className="font-bold text-stone-800 text-sm mb-1" data-id="element-267">
              Privacy Protetta
            </span>
            <span className="text-xs text-gray-500" data-id="element-268">
              Dati personali al sicuro
            </span>
          </div>
          <div className="flex flex-col items-center col-span-2 md:col-span-1" data-id="element-269">
            <span className="font-bold text-stone-800 text-sm mb-1" data-id="element-270">
              Supporto Dedicato
            </span>
            <span className="text-xs text-gray-500" data-id="element-271">Assistenza via email</span>
          </div>
        </div>

        <div className="border-t border-gray-100 pt-6" data-id="element-272">
          <PaymentBadges data-id="element-273" />
        </div>
      </div>
    </section>;
}